import "./SinglePostTemplate.module.css"
import Header from "@/reusable_sections/Header"
import SinglePost from "./sections/SinglePost"
import Footer from "@/reusable_sections/Footer"

export default function SinglePostTemplatePage() {

  return (
    <div>
      <Header />
      <SinglePost />
      <Footer />
    </div>
  )
}
